import { Scene as BaseScene } from "three";

export default class Scene extends BaseScene {
    updateMaterials()
    {
        this.traverse( child => {
            if ( child.material ) {
                child.material.needsUpdate = true;
            }
        } );
    }
}